import BulletButton, { BulletButtonProps } from '../babu/BulletButton'

export default function BottomButtonArea(props: BulletButtonProps) {
  return (
    <div className="fixed bg-white bottom-0 left-0 right-0 border-t border-bg200 z-10">
      <div className="container py-m">
        <BulletButton {...props} />
      </div>
    </div>
  )
}
